module.exports = __webpack_public_path__ + "static/media/portfolio 3.135bbdb3.JPG";